import {z} from 'zod';

export const interestCreateFormSchema = z.object({
  customer: z
    .object({
      id: z.string().nullable(),
    })
    .nullable()
    .optional(),
  sourceCodeId: z.array(z.string()).min(1),
});

export type InterestCreateFormSchemaType = z.infer<typeof interestCreateFormSchema>;
